<div class="change-request-list">List view placeholder</div>
